import React from "react";
import { BackgroundColorI, TitleType } from "../Types";
import { getTitleHTMLTag } from "../../helpers/tools";
import Button from "../Inputs/Button";
import TrustPilotDS, {
  FiveStars,
  TrustPilotLogo,
} from "../TrustPilot/TrustPilotDS";
import { useDragScroll } from "../Hooks";

interface ReviewCardsI {
  data: {
    BackgroundColor: BackgroundColorI;
    CardsContent: {
      Date: string;
      Name: string;
      Review: string;
      ReviewTitle: string;
    }[];
    ExcellentText: string;
    GhostButtonID: string;
    GhostButtonLabel: string;
    GhostButtonURL: string;
    GhostNewTab: boolean;
    GhostNoFollow: boolean;
    HasGhostButton: boolean;
    HasSubtitle: boolean;
    HasTitle: boolean;
    HasTrustpilotRating: boolean;
    SansTitle: string;
    SerifTitle: string;
    Subtitle: string;
    TitleHeading: {
      TitleTypeSelection: TitleType;
    };
    TrustpilotLink: string;
    TrustpilotScore: string;
  };
}

const ReviewCards = ({ data }: ReviewCardsI) => {
  const [ref] = useDragScroll();
  const {
    BackgroundColor,
    CardsContent,
    ExcellentText,
    GhostButtonID,
    GhostButtonLabel,
    GhostButtonURL,
    GhostNewTab,
    GhostNoFollow,
    HasGhostButton,
    HasSubtitle,
    HasTitle,
    HasTrustpilotRating,
    SansTitle,
    SerifTitle,
    Subtitle,
    TitleHeading,
    TrustpilotLink,
    TrustpilotScore,
  } = data;

  const backgroundColor = {
    Blue_Gray: "#F5F7FA",
    Light_Blue: "#ECF0FF",
    White: "#FFFFFF",
  }[BackgroundColor.BackgroundColor || "White"];

  const cardBackgroundColor = {
    Blue_Gray: "#FFFFFF",
    Light_Blue: "#FFFFFF",
    White: "#F5F7FA",
  }[BackgroundColor.BackgroundColor || "White"];

  const titleC = HasTitle
    ? getTitleHTMLTag(
        <>
          <span className="font-DM font-bold H2">{SansTitle} </span>
          <span className="font-MW font-light H2">{SerifTitle}</span>
        </>,
        TitleHeading?.TitleTypeSelection,
        "text-[#424242] md:text-center"
      )
    : null;

  const subtitleC = HasSubtitle
    ? getTitleHTMLTag(
        <span className="font-DM font-normal H4">{Subtitle}</span>,
        "p",
        "text-[#424242] md:text-center"
      )
    : null;
 if (process.env.GATSBY_APP_LOCALE === "it") {
  return (
    <section className="overflow-hidden" style={{ backgroundColor }}>
      <div className="flex flex-col max-w-content mx-auto py-[64px] xl:px-[0px] px-[24px] md:gap-[64px] gap-[32px]">
        <div className="flex flex-col md:gap-[16px] gap-[8px]">
          {titleC}
          {subtitleC}
        </div>
        {HasTrustpilotRating ? (
          <TrustPilotDS
            CurrentRateLabel={TrustpilotScore}
            OutOfLabel={ExcellentText}
            className={`!text-center`}
            typography={"BodyL"}
            TrustpilotLink={TrustpilotLink}
            ratingFirst={true}
          />
        ) : null}
        {CardsContent && CardsContent.length > 0 ? (
          <div
            className="flex flex-row gap-[32px] overflow-x-auto hide-scrollbar"
            ref={ref}
          >
            {CardsContent.map((content, idx) => (
              <CardContent
                data={content}
                backgroundColor={cardBackgroundColor}
                key={`${content.ReviewTitle}_${idx}`}
              />
            ))}
          </div>
        ) : null}
        {HasGhostButton ? (
          <Button
            label={GhostButtonLabel}
            href={GhostButtonURL}
            ghost={true}
            newTab={GhostNewTab}
            noFollow={GhostNoFollow}
            id={GhostButtonID}
            size="40"
            wrapperClassname="!w-fit mx-auto"
            secondary
          />
        ) : null}
      </div>
    </section>
  );
}

return <></>
};

const CardContent = ({ data, backgroundColor }: any) => {
  const { Date, Name, Review, ReviewTitle } = data;
  return (
    <div
      className="p-[24px] rounded-[24px] flex flex-col gap-[16px] md:flex-[352px] md:min-w-[352px] flex-[240px] min-w-[240px] min-h-[415px]"
      style={{ backgroundColor }}
    >
      <TrustPilotLogo />
      <div className="flex flex-col gap-[16px] mt-[16px]">
        <span className="H4 font-bold text-[#424242]">{ReviewTitle}</span>
        <p className="BodyL font-normal text-[#555555]">{Review}</p>
      </div>
      <div className="flex flex-col gap-[4px] mt-auto">
        <span className="BodyL font-bold text-[#555555]">{Name}</span>
        <FiveStars />
        <span className="BodyS font-normal text-[#686868]">{Date}</span>
      </div>
    </div>
  );
};

export default ReviewCards;
